import {ObjectDTO} from '../../../object-dto';
import {PrixDto} from '../../../prix-dto';

export class LigneFactureClientProduitComplementaireDto extends ObjectDTO {

  idFactureClient: number;
  codePlc: string;
  libellePlc: string;
  codeProduitDeclinaison: string;
  libelleProduitDeclinaison: string;
  uniteDeMesure: string;
  quantite: number;
  montantUnitaire: PrixDto;
  montantHT: PrixDto;
  montantTTC: PrixDto;
  tauxTVA: number;

  public static getAllProperties = (): String => {
    return `
      id,
      codePlc,
      libellePlc,
      codeProduitDeclinaison,
      libelleProduitDeclinaison,
      uniteDeMesure,
      quantite,
      montantUnitaire {
        value,
        uniteMonetaire
      },
      montantHT {
        value,
        uniteMonetaire
      },
      montantTTC {
        value,
        uniteMonetaire
      },
      tauxTVA
    `
  }
}
